<style scoped>
table {
  width: 100%;
  table-layout: fixed;
}

.dist-panel {
  background: white;
  width: 700px;
  /* box-shadow: 0 0 2px darkgrey;
  -webkit-box-shadow:0 0 2px darkgrey;
  -moz-box-shadow:0 0 2px darkgrey; */
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 30px;
}

tr {
  height: 35px;
}

td:nth-child(1) {
  width: 140px;
}

td:nth-child(2) {
  color: black;
  width: 300px;
}
</style>

<template>
  <div>
    <div class="dist-panel">
      <!-- <Divider /> -->
      <table>
        <tr>
          <td>项目识别号：</td>
          <td>{{detail.rowguid}}</td>
          <td><Button size="small" @click="copyRowguid(detail.rowguid)">复制</Button></td>
        </tr>
        <tr>
          <td>所属BG：</td>
          <td>{{detail.BGCodeTxt}}</td>
        </tr>
        <tr>
          <td>所属BU：</td>
          <td>{{detail.ZhuBuCodeTxt}}</td>
        </tr>
        <tr>
          <td>项目阶段：</td>
          <td>{{detail.current_prj_phase}}</td>
        </tr>
        <tr>
          <td>项目日期：</td>
          <td>{{detail.lixiangsj.split(" ")[0]}}</td>
        </tr>
        <tr>
          <td>项目经理：</td>
          <td>{{detail.pm}}</td>
        </tr>
        <tr>
          <td>项目经理部门：</td>
          <td>{{detail.pm_dept_name}}</td>
        </tr>
        <tr>
          <td>项目经理部门领导：</td>
          <td>{{detail.pm_dept_manager}}</td>
        </tr>
        <tr>
          <td>维护负责人：</td>
          <td>{{detail.ops}}</td>
        </tr>
        <tr>
          <td>维护负责人部门：</td>
          <td>{{detail.ops_dept_name}}</td>
        </tr>
        <tr>
          <td>维护负责人部门领导：</td>
          <td>{{detail.ops_dept_manager}}</td>
        </tr>
        <!-- <tr>
          <td>项目管控表：</td>
          <td>
            <a @click="showAddPlanUrlModal" v-if="prj.planurl == null || prj.planurl.length == 0">添加</a>
            <div v-else>
              <a :href="prj.planurl" target="_blank">{{prj.planurl}}</a>
              <Button size="small" type="text" style="margin-left:10px" @click="removePlanUrl">移除</Button>
            </div>
          </td>
        </tr>-->
        <!-- <tr>
          <td>项目标签：</td>
          <td>
            <a @click="showAddTagsModal">添加</a>
          </td>
        </tr>-->
      </table>
      <Divider />
      <div>
        <Button icon="md-add" @click="showAddTagsModal" size="small">添加标签</Button>
        <div style="margin-top:10px">
          <!-- <Button v-for="tag in tagsList" :key="tag.id">{{getTagName(tag.tag)}}</Button> -->
          <Tag color="primary" v-for="tag in tagsList" :key="tag.id">{{getTagName(tag.tag)}}</Tag>
        </div>
      </div>
    </div>

    <Modal v-model="addPlanModal.modal" title="添加">
      <Input placeholder="项目管控在线地址" v-model="addPlanModal.model.planurl" />
      <div slot="footer">
        <Button type="text" size="large" @click="addPlanUrlCancel">取消</Button>
        <Button
          type="primary"
          size="large"
          @click="addPlanUrlConfirm(addPlanModal.model.planurl)"
        >确定</Button>
      </div>
    </Modal>

    <Modal v-model="addTagsModal.modal" title="选择标签" @on-visible-change="onTagAddModalVisible">
      <!-- <Tag
        :color="tagColor[Math.floor(Math.random()*tagColor.length)]"
        v-for="item in tagItem"
        :key="item.itemvalue"
        :checkable="true"
        :checked="true"
      >{{item.itemtext}}</Tag>-->

      <Button
        size="small"
        v-for="item in tagItem"
        :key="item.itemvalue"
        style="margin:10px"
        @click="addTagV2(item)"
        :type="item.selected?'info':'default'"
      >{{item.itemtext}}</Button>
      <div slot="footer">
        <Button type="text" size="large" @click="addTagCancel">取消</Button>
        <Button type="primary" size="large" @click="addTagSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectguid: this.$route.params.projectguid,
      detail: {},
      prj: {},
      addPlanModal: {
        modal: false,
        model: {
          planurl: ""
        }
      },
      addTagsModal: {
        modal: false,
        model: []
      },
      tagItem: [],
      tagColor: ["primary", "success", "warning", "error"],
      tagsList: []
    };
  },
  methods: {
    getProject() {
      let _this = this;
      this.$http.get({
        method: "mqms/project/get",
        params: {
          projectguid: this.projectguid
        },
        success: function(data) {
          _this.prj = data;
        }
      });
    },
    getDetail() {
      let _this = this;
      this.$http.get({
        method: "pmsys/getdetail",
        params: {
          rowguid: this.projectguid
        },
        success: function(data) {
          _this.detail = data;
        },
        failure(code, msg) {}
      });
    },
    showAddPlanUrlModal() {
      this.addPlanModal.modal = true;
      this.addPlanModal.model.planurl = "";
    },
    addPlanUrlCancel() {
      this.addPlanModal.modal = false;
    },
    addPlanUrlConfirm(url) {
      let _this = this;
      this.$http.post({
        method: "mqms/project/updateplanurl",
        params: {
          projectguid: this.projectguid,
          planurl: url
        },
        success: function(data) {
          _this.getProject();
          _this.addPlanModal.modal = false;
        },
        failure(code, msg) {
          _this.$Message.warning(msg);
        }
      });
    },
    removePlanUrl() {
      let _this = this;
      this.$Modal.confirm({
        title: "提示",
        content: "确定移除吗？",
        onOk: () => {
          _this.$http.post({
            method: "mqms/project/removeplanurl",
            params: {
              projectguid: _this.projectguid
            },
            success: function(data) {
              _this.getProject();
            }
          });
        }
      });
    },
    showAddTagsModal() {
      if (this.tagItem.length == 0) {
        this.getTagItem();
      } else {
        this.addTagsModal.modal = true;
      }
    },
    getTagItem() {
      let _this = this;
      this.$http.get({
        method: "base/dictitem/listbydictcode",
        params: {
          dictcode: "project_tags"
        },
        success: function(data) {
          _this.tagItem = data;
        }
      });
    },
    addTag(item) {
      Array.prototype.remove = function(val) {
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      this.tagItem.remove(item);
    },
    addTagV2(item) {
      let index = this.tagItem.indexOf(item);
      if (item.selected) {
        item.selected = false;
      } else {
        item.selected = true;
      }
      //改变数组，更新视图设置
      this.$set(this.tagItem, index, item);
    },
    addTagCancel() {
      this.addTagsModal.modal = false;
    },
    addTagSubmit() {
      let submitData = [];
      for (let i = 0; i < this.tagItem.length; i++) {
        if (this.tagItem[i].selected) {
          submitData.push(this.tagItem[i].itemvalue);
        }
      }
      let _this = this;
      this.$http.post({
        method: "mqms/project/addtags",
        params: {
          projectguid: this.projectguid,
          ids: submitData
        },
        success: function(data) {
          _this.addTagsModal.modal = false;
          _this.getTags();
        }
      });
    },
    getTags() {
      let _this = this;
      this.$http.get({
        method: "mqms/project/gettags",
        params: {
          projectguid: this.projectguid
        },
        success: function(data) {
          _this.tagsList = data;
        }
      });
    },
    getTagName(id) {
      for (let i = 0; i < this.tagItem.length; i++) {
        if (this.tagItem[i].itemvalue == id) {
          return this.tagItem[i].itemtext;
        }
      }
    },
    onTagAddModalVisible(visible) {
      if (visible) {
        this.restoreTagItem();
      } else {
        for (let i = 0; i < this.tagItem.length; i++) {
          this.tagItem[i].selected = false;
        }
      }
    },
    restoreTagItem() {
      for (let i = 0; i < this.tagItem.length; i++) {
        for (let j = 0; j < this.tagsList.length; j++) {
          if (this.tagItem[i].itemvalue == this.tagsList[j].tag) {
            this.tagItem[i].selected = true;
            this.$set(this.tagItem, i, this.tagItem[i]);
          }
        }
      }
    },
    copyRowguid(rowguid) {
      var input = document.createElement("input"); // 创建input对象
      input.value = rowguid; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$Message.success({
          title: "提示",
          content: "复制成功"
      });
    }
  },
  mounted() {
    this.getDetail();
    this.getProject();
    this.getTagItem();
    this.getTags();
  }
};
</script>